import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { Input, Space } from 'udesk-ui';

const Wrapper = styled.div`
    padding: 8px;
    background-color: ${(props) => (props.hasBackGround ? '#ccc' : '')};
    min-height: 32px;
`;

const Item = styled.div`
    margin-bottom: 10px;
`;

const KeyWrapper = styled.div`
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
`;

const ValueWrapper = styled.div`
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface TemplateProps {
    title?: string;
    value?: {
        key?: string;
        value?: any;
    }[];
    onChange?: (value: TemplateProps['value']) => void;
    readonly?: boolean;
    hasBackGround?: boolean;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, readonly, hasBackGround } = props;

    const onValueChange = (idx: number, v: string) => {
        const newValue = value?.map((item, _idx) => {
            if (idx === _idx) {
                return {
                    ...item,
                    value: v,
                };
            } else {
                return item;
            }
        });

        onChange?.(newValue);
    };

    return (
        <Wrapper hasBackGround={hasBackGround}>
            {value
                ?.filter((item) => item.key)
                ?.map((item, idx) => {
                    return (
                        <Item key={item.key!}>
                            <Space>
                                <KeyWrapper title={item.key}>{item.key}</KeyWrapper>

                                <span>=</span>

                                {readonly ? (
                                    <ValueWrapper>{item.value}</ValueWrapper>
                                ) : (
                                    <Input
                                        style={{ width: 200 }}
                                        value={item.value}
                                        onChange={(e) => onValueChange(idx, e.target.value)}
                                    />
                                )}
                            </Space>
                        </Item>
                    );
                })}
        </Wrapper>
    );
});

export default Template;
